import type { ProductColor } from '@aloft/toolkit-shared';

import type { PropsWithChildren } from 'react';

import { Td as PDFTd } from '../../components/pdf-export/Td/Td.tsx';
import { Td as WebTd } from '../../components/table.tsx';
import { useIsPDF } from '../internal/useIsPDF.ts';

type Props = PropsWithChildren<{
  width?: string;
  textAlign?: 'right' | 'left';
  colSpan?: number;
  border?: string;
  isFirstRow?: boolean;
  isFirstColumn?: boolean;
  rowSpan?: number;
  backgroundColor?: ProductColor;
  height?: string;

  /** @deprecated this doesn't make sense on Td and might go away */
  justifyContent?: 'flex-end';
}>;

export const Td = (props: Props) => {
  const { children, ...rest } = props;
  return useIsPDF() ? <PDFTd {...rest}>{children}</PDFTd> : <WebTd {...rest}>{children}</WebTd>;
};
